import { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';

interface StatusConfig {
  active: boolean;
  message: string;
}

export const StatusBanner: React.FC = () => {
  const [status, setStatus] = useState<StatusConfig | null>(null);

  useEffect(() => {
    const fetchStatus = () => {
      fetch('/api/status')
        .then((res) => res.json())
        .then((data: StatusConfig) => setStatus(data))
        .catch(() => setStatus(null));
    };

    fetchStatus();
    const interval = setInterval(fetchStatus, 120_000);
    return () => clearInterval(interval);
  }, []);

  const isActive = !!status?.active;

  return (
    <div
      className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
        isActive ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
      }`}
    >
      <div className="overflow-hidden">
        <div className="bg-amber-500/10 border-b border-amber-500/20 px-4 py-2.5 text-center text-sm">
          <div className="flex items-center justify-center gap-2 text-amber-700 dark:text-amber-400">
            <AlertTriangle className="h-4 w-4 shrink-0" />
            <span>{status?.message}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
